import { Alert, Button, Combobox } from "@playbookai/ui";
import type { usePersonalPreferences } from "./usePersonalPreferences.js";
export function PersonalProfileControl({
  state,
}: {
  state: ReturnType<typeof usePersonalPreferences>;
}) {
  const selected =
    state.failed && "default_profile_id" in state.failed
      ? state.failed.default_profile_id
      : state.query.data?.default_profile_id;
  const available = state.profiles.data?.profiles ?? [];
  return (
    <div className="min-w-0 space-y-2">
      <Combobox
        label="Model"
        value={selected ?? ""}
        disabled={
          state.pending || state.profiles.isPending || !state.query.data
        }
        placeholder="Search profiles"
        options={[
          { value: "", label: "Workspace default" },
          ...available.map((p) => ({
            value: p.id,
            label: [p.display_name, p.provider_name, p.model_name]
              .filter(Boolean)
              .join(" · "),
          })),
        ]}
        onChange={(id) => void state.save({ default_profile_id: id || null })}
      />
      {selected &&
        state.profiles.isSuccess &&
        !available.some((p) => p.id === selected) &&
        !state.profiles.isPending && (
          <Alert tone="watch">
            Your selected profile is unavailable. Choose another profile for new
            conversations.
          </Alert>
        )}
      {state.profiles.isError && (
        <Alert tone="critical">
          Could not load profiles.{" "}
          <Button size="sm" onClick={() => void state.profiles.refetch()}>
            Retry profiles
          </Button>
        </Alert>
      )}
      <p className="text-caption text-pb-text-muted">
        Existing conversations keep their current profile.
      </p>
    </div>
  );
}
